/**
 * Stabile Zeilen-ID für Multi-Produkt-Achats (ein Beleg, mehrere productId).
 * purchaseId allein reicht nicht — sonst bleibt nur die letzte Zeile.
 */
export function purchaseLineEntityId(item) {
  if (!item || typeof item !== 'object') return '';
  const lineId = item.id;
  if (lineId != null && lineId !== '') return String(lineId);
  const purchaseId = item.purchaseId;
  const productId = item.productId;
  if (
    purchaseId != null &&
    purchaseId !== '' &&
    productId != null &&
    productId !== ''
  ) {
    return `${purchaseId}:${productId}`;
  }
  if (purchaseId != null && purchaseId !== '') return String(purchaseId);
  return '';
}
